import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as actions from "../../../Redux/Actions";
import MainCard from "../../../component/MainCard/MainCard";
import Button from "../../../component/Buttons/Button";
import SearchBar from "../../../component/SearchBar/SearchBar";
import ModalComponents from "../../../component/ModalComponent/ModalComponent";
import ConfirmDialog from "../../SuccessionPlanning/ConfirmDialog";
import {
  showErrorToastMessage,
  showSuccessToastMessage,
} from "../../../component/Toasts/Toasts";
import hanldeUnauthorizedUser from "../../../component/AccessConditions/UnauthorizedUser";
import { icons } from "../../../assets";
import AddOrEditKra from "./AddOrEditKra";

const KraLibrary = () => {
  const { unAuthorizeUser } = hanldeUnauthorizedUser();
  const dispatch = useDispatch();

  const [kras, setKras] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState<any>("");
  const [confirmDelete, setConfirmDelete] = useState<any>(null);

  const userLogin: any = localStorage.getItem("login");
  const loginId = JSON.parse(userLogin || "{}")?.id;

  const handleApiCall = () => {
    dispatch(
      actions.getAllKrasAction((res: any) => {
        if (res?.data) setKras(res.data);
      })
    );
  };

  useEffect(() => {
    unAuthorizeUser();
    handleApiCall();
  }, []);

  const handleEditClick = (row: any) => {
    setEditData(row);
    setShowModal(true);
  };

  const handleDelete = (row: any) => {
    dispatch(
      actions.deleteKraAction(row._id, (res: any) => {
        setConfirmDelete(null);
        if (res?.error) {
          const msg =
            res?.error?.response?.data?.error?.error_description ||
            "Failed to delete KRA";
          showErrorToastMessage(msg);
        } else {
          showSuccessToastMessage("KRA deleted successfully");
          handleApiCall();
        }
      })
    );
  };

  const term = searchValue.toLowerCase();
  const filtered = kras.filter(
    (k) =>
      (k.title || "").toLowerCase().includes(term) ||
      (k.description || "").toLowerCase().includes(term)
  );

  return (
    <MainCard>
      <div className="assessment-heading-button-wrapper">
        <div>
          <h2>KRA Library</h2>
        </div>
        <div className="btn-wrapper">
          <Button
            title="+ Add KRA"
            onClick={() => {
              setEditData("");
              setShowModal(true);
            }}
            className="add-employee-btn"
          />
        </div>
      </div>

      <div className="mt-2">
        <div className="assessment-searchbar-wrapper mx-2 mt-3">
          <SearchBar
            filter={searchValue}
            setFilter={setSearchValue}
            onSearchClicked={() => {}}
          />
        </div>

        {filtered.length > 0 ? (
          <div className="table table-responsive">
            <table className="table-main table table-sm mt-3">
              <thead className="table-head">
                <tr className="table-head-row">
                  <th className="table-head-row" scope="col">KRA</th>
                  <th className="table-head-row" scope="col">Description</th>
                  <th className="table-head-row" scope="col">Action</th>
                </tr>
              </thead>
              <tbody className="table-body">
                {filtered.map((k) => (
                  <tr className="table-body-row" key={k._id}>
                    <td>{k.title}</td>
                    <td>{k.description || "-"}</td>
                    <td>
                      <div className="action-btn">
                        <img
                          title="Edit"
                          src={icons.edit_icon}
                          alt="edit"
                          className="edit-icon"
                          onClick={() => handleEditClick(k)}
                        />
                        <img
                          title="Delete"
                          src={icons.delete_icon}
                          alt="delete"
                          className="edit-icon"
                          style={{ marginLeft: 10 }}
                          onClick={() => setConfirmDelete(k)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="employeedata mt-2">No KRAs found</p>
        )}
      </div>

      <ModalComponents
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setEditData("");
        }}
        title={editData ? "Edit KRA" : "Add KRA"}
        modalBody={
          <AddOrEditKra
            editData={editData}
            loginId={loginId}
            setShowModal={setShowModal}
            setEditData={setEditData}
            handleApiCall={handleApiCall}
          />
        }
        className="modal-md"
      />

      <ModalComponents
        show={!!confirmDelete}
        onHide={() => setConfirmDelete(null)}
        title="Delete KRA"
        modalBody={
          confirmDelete ? (
            <ConfirmDialog
              message={`Delete the KRA "${confirmDelete.title}"?`}
              detail="It will be removed from any designation weightage that uses it."
              confirmLabel="Delete"
              onConfirm={() => handleDelete(confirmDelete)}
              onCancel={() => setConfirmDelete(null)}
            />
          ) : null
        }
        className="modal-md"
      />
    </MainCard>
  );
};

export default KraLibrary;
